export const defaultScopeId = "v3.organisation";
export const contextKey = "organisation";

export const CURRENT_ORGANISATION_REQUESTED = "ORGANISATION/CURRENT_ORGANISATION_REQUESTED";
export const CURRENT_ORGANISATION_SUCCEEDED = "ORGANISATION/CURRENT_ORGANISATION_SUCCEEDED";
export const CURRENT_ORGANISATION_FAILED = "ORGANISATION/CURRENT_ORGANISATION_FAILED";

// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        currentOrganisation: null,
        errors: [],
        hasInitialData: false,
        loading: 0,
    },
    { type, data }
) => {
    switch (type) {
    case CURRENT_ORGANISATION_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CURRENT_ORGANISATION_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.currentOrganisation = data;
        return state;
    }
    case CURRENT_ORGANISATION_FAILED: {
        --state.loading;
        state.errors.push(data);
        return state;
    }
    default:
        return state;
    }
};

export const requestCurrentOrganisation = (data, resolve, reject) => ({ type: CURRENT_ORGANISATION_REQUESTED, data, resolve, reject });
export const succeedCurrentOrganisation = data => ({ type: CURRENT_ORGANISATION_SUCCEEDED, data });
export const failCurrentOrganisation = data => ({ type: CURRENT_ORGANISATION_FAILED, data });

